import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import RestitutionCoordinatesForm from '../Forms/RestitutionCoordinatesForm';

const RestitutionCoordinatesModal = ({
    handleToggleModal,
    isOpen,
    isEdit,
    dataCoordinates,
    handleSave,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={handleToggleModal}
            size='lg'
            className='border-0'
            modalClassName='modal fade zoomIn'
            backdrop={'static'}
            centered={true}
            unmountOnClose={true}
        >
            <ModalHeader toggle={handleToggleModal}>
                {isEdit ? 'Editar' : 'Agregar'} Registro de Coordenadas de Restitución
            </ModalHeader>

            <RestitutionCoordinatesForm
                dataCoordinates={dataCoordinates}
                isEdit={isEdit}
                isOpen={isOpen}
                handleToggleModal={handleToggleModal}
                handleSave={handleSave}
            />
        </Modal>
    );
};

export default RestitutionCoordinatesModal;